import React, { useContext, useEffect, useRef, useState } from 'react';
import { Grid, useTheme } from "@mui/material";
import { useLocation } from 'react-router-dom';
import { useFormContext } from '../Context/Context';
import { useReadOnly } from '../Context/ReadOnlyContext';
import { FinalValuesContext } from '../Context/FinalValuesContext';
import ConvertTitle from './ConvertTitle';
import ScaleHeader from './ScaleRating/ScaleHeader';
import RatingButtons from './ScaleRating/RatingButtons';
import BestWorstInputs from './ScaleRating/BestWorstInputs';
import {
  getInitialValues,
  handleActiveColor,
  isPublishReadOnly,
  fillInputValue,
} from './ScaleRating/scaleHelpers';

const ScaleRating = ({ id, header, bestTitle, worthTitle }) => {

  const { drawerData } = useFormContext();
  const { readOnly } = useReadOnly();
  const { finalSelectValues } = useContext(FinalValuesContext);
  const location = useLocation();
  const currentPage = location.pathname;
  const theme = useTheme();

  const existingComponentIndex = drawerData.findIndex(component => component.id === id);
  const componentState = drawerData[existingComponentIndex]?.state || {};

  const {
    initialScaleValue,
    initialSubHeader,
    initialBestValue,
    initialWorthValue,
    initialRating,
  } = getInitialValues({ header, bestTitle, worthTitle, state: componentState });

  const [active, setActive] = useState(initialRating);
  const [activeColor, setActiveColor] = useState('');
  const [scaleValue, setScaleValue] = useState(initialScaleValue);
  const [bestValue, setBestValue] = useState(initialBestValue);
  const [worthValue, setWorthValue] = useState(initialWorthValue);
  const [isHeadingFocused, setHeadingFocused] = useState(false);

  const containerRef = useRef(null);

  const isReadOnly = isPublishReadOnly(currentPage, readOnly, finalSelectValues, drawerData);
  const marginBottom = currentPage.startsWith('/build') || currentPage.startsWith('/publish') ? '28px' : '50px';


  let HeadingColor = theme.palette.blue[700]

  useEffect(() => {
    fillInputValue(drawerData, existingComponentIndex, {
      scaleValue,
      bestValue,
      worthValue,
      active,
      readOnly,
    });
  }, [scaleValue, bestValue, worthValue, active]);

  useEffect(() => {
    setActiveColor(handleActiveColor(active, theme));
  }, [active]);

  const handleClickOutside = (event) => {
    if (!containerRef.current?.contains(event.target)) {
      setHeadingFocused(false);
    } else {
      setHeadingFocused(true);
    }
  };

  useEffect(() => {
    document.addEventListener('click', handleClickOutside);
    return () => document.removeEventListener('click', handleClickOutside);
  }, []);

  return (
    <Grid
      mb={marginBottom}
      p="12px 10px"
      mx={currentPage === '/build' || currentPage === '/publish' ? '4px' : '0px'}
      borderRadius="3px"
      bgcolor="white"
      ref={containerRef}
      border={`2px solid ${isHeadingFocused && !isReadOnly ? '#0293e2' : 'transparent'}`}
    >
      <ScaleHeader
        value={scaleValue}
        setValue={setScaleValue}
        isReadOnly={isReadOnly}
        onFocus={() => setHeadingFocused(true)}
        handleClickOutside={handleClickOutside}
        HeadingColor={HeadingColor}
      />
      <RatingButtons
        active={active}
        setActive={setActive}
        activeColor={activeColor}
        isReadOnly={isReadOnly}
      />
      <BestWorstInputs
        bestValue={bestValue}
        setBestValue={setBestValue}
        worthValue={worthValue}
        setWorthValue={setWorthValue}
        isReadOnly={isReadOnly}
        onFocus={() => setHeadingFocused(true)}
      />
    </Grid>
  );
};

export default ScaleRating;